<template>
	<section v-if="items.length" class="promotions background-light main-content align-center">
		<div class="row row-header align-center">
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
		</div>
		<div class="row promotions-row flex-row slide-row">
			<client-only>
				<nuxt-link
					v-for="promoblock in items.slice(0, 4)"
					:key="promoblock.ID"
					:to="localePath(`/${promoblock.link}`)"
					class="slick-item columns column3"
				>
					<div class="slick-slide-content">
						<h3>{{ promoblock.header }}</h3>
						<span>
							{{ promoblock.button }}
							<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
						</span>
					</div>
					<picture>
						<source v-if="promoblock.imageWebp" :srcset="promoblock.imageWebp" type="image/webp" />
						<source :srcset="promoblock.image" />
						<img loading="lazy" :src="promoblock.image" :alt="promoblock.imageAlt" />
					</picture>
				</nuxt-link>
			</client-only>
		</div>
		<picture class="intro-bg">
			<source srcset="~/assets/images/promotions-section-bg-image-flipped.webp" type="image/webp" />
			<source srcset="~/assets/images/promotions-section-bg-image-flipped.png" />
			<img
				src="~/assets/images/promotions-section-bg-image-flipped.png"
				alt="Breathe Boutique Hotel Leiden"
				loading="lazy"
			/>
		</picture>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	subtitle: { type: String, default: '' },
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
	header: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.background-light {
	position: relative;
	background: #f1ebe1 !important;

	.row {
		position: relative;
		z-index: 2;
	}

	.intro-bg {
		object-fit: cover;
		position: absolute;
		inset: 0;
		z-index: 1;

		img {
			width: 100%;
			height: 100% !important;
			object-fit: cover;
		}
	}
}
</style>
